export default __webpack_public_path__ + "static/food-8255806cf4aa3993ba78f3f7c6f3139b.jpg";